import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var format_italic_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M12.5 5L10 19h1.9l2.5-14z" }) });
export {
  format_italic_default as default
};
//# sourceMappingURL=format-italic.js.map
